(function () {
  const indicators = document.querySelectorAll(".slider .indicators .indicator");
  const arrowPrev = document.querySelector(".focus-cards .arrows .arrow-prev");
  const arrowNext = document.querySelector(".focus-cards .arrows .arrow-next");

  const handleIndicatorClick = (event) => {
    const indicator = event.target;
    if (!isActive(indicator)) {
      removeActive();
      addActive(indicator);
      showSlide(indicator.dataset.slide);
    }
  };

  const handlePrevArrowClick = () => {
    let activeSlide = 0;
    let newActiveSlide = indicators.length;
    let ready = false;

    indicators.forEach((indicator) => {
      if (isActive(indicator) && !ready) {
        activeSlide = indicator.dataset.slide;
        if (activeSlide !== "1") {
          newActiveSlide = parseInt(activeSlide) - 1;
        }
        removeActive();
        addActive(document.querySelector(`.slider .indicators [data-slide='${newActiveSlide}']`));
        showSlide(newActiveSlide);
        ready = true;
      }
    });
  };

  const handleNextArrowClick = () => {
    let activeSlide = 0;
    let newActiveSlide = 1;
    let ready = false;

    indicators.forEach((indicator) => {
      if (isActive(indicator) && !ready) {
        activeSlide = indicator.dataset.slide;
        if (activeSlide !== indicators.length.toString()) {
          newActiveSlide = parseInt(activeSlide) + 1;
        }
        removeActive();
        addActive(document.querySelector(`.slider .indicators [data-slide='${newActiveSlide}']`));
        showSlide(newActiveSlide);
        ready = true;
      }
    });
  };

  indicators.forEach((indicator) => {
    indicator.addEventListener("click", handleIndicatorClick);
  });

  if (arrowPrev && arrowNext) {
    arrowPrev.addEventListener("click", handlePrevArrowClick);
    arrowNext.addEventListener("click", handleNextArrowClick);
  }

  function isActive(indicator) {
    return indicator.hasAttribute("active");
  }

  function removeActive() {
    document.querySelectorAll(".slider .indicators [active]").forEach((item) => {
      item.removeAttribute("active");
    });
  }

  function addActive(indicator) {
    indicator.setAttribute("active", "");
  }

  function showSlide(newActiveSlide) {
    const newPosition = (100 * (newActiveSlide - 1)).toString();
    document.querySelector(".slider-inner").style.marginLeft = `-${newPosition}%`;
  }

  // randomize focus carousal starting slide
  const randActiveSlide = Math.floor(Math.random() * 3 + 1);

  if (indicators.length) {
    removeActive();
    addActive(document.querySelector(`.slider .indicators [data-slide='${randActiveSlide}']`));
    showSlide(randActiveSlide);

    // timer for autoplay in carousal
    setInterval(function () {
      handleNextArrowClick();
    }, 20000);
  }
})();
